import React, { useState, useEffect } from "react";
import Select from "react-select";
import { SERVER_BASE } from "../config/server";
import apiClient from "../utils/apiClient";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTrashAlt,
  faPlusCircle,
  faMinusCircle,
  faEdit,
  faMinus,
  faPlus,
  faTrash,
  prefix,
} from "@fortawesome/free-solid-svg-icons";
import "bootstrap/dist/css/bootstrap.min.css";
import InventoryModal from "./InventoryModal";
import Swal from "sweetalert2";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";

import { ModeOfTransportOptions, returnableOptions } from "./masterList";

const DeliveryChallan = ({ setUnsavedChanges, setPrefix, setRefNo }) => {
  const [prefixOptions, setPrefixOptions] = useState([]);
  const [loading, setLoading] = useState(false); // Track loading state
  const centerCode = localStorage.getItem("code");
  const token = localStorage.getItem("token");
  const email = localStorage.getItem("email");
  const username = localStorage.getItem("username");
  const [ledgerOptions, setLedgerOptions] = useState([]);
  const [purposeOptions, setPurposeOptions] = useState([]);
  const [TranportersOptions, setTranportersOptions] = useState([]);
  const [certificateText, setCertificateText] = useState("");
  const [transhipCertificateText, setTranshipCertificateText] = useState("");
  const [normalCertificateText, setNormalCertificateText] = useState("");
  const [activeTab, setActiveTab] = useState(0);
  const [inventoryOptions, setInventoryOptions] = useState([]);
  const [isPrefixEmpty, setIsPrefixEmpty] = useState(true);
  const [isReturnable, setIsReturnable] = useState(true);
  const [isEditable, setIsEditable] = useState(false);
  const [profileDetails, setProfileDetails] = useState(null);
  const [projectOptions, setProjectOptions] = useState([]);
  const [editLoading, setEditLoading] = useState(false);
  const name = localStorage.getItem("name");
  const badgeId = localStorage.getItem("badgeId");
  const navigate = useNavigate();
  const [showPermissionModal, setShowPermissionModal] = useState(false);
  const [validatedPayload, setValidatedPayload] = useState(null);
  const [hasLedgerChanged, setHasLedgerChanged] = useState(false);
  const [nextRowId, setNextRowId] = useState(2);


  const [challanInfo, setChallanInfo] = useState({
    dispatchFrom: "Radha Soami Satsang Beas",
    prefix: "",
    refNo: "",
    date: new Date().toISOString().split("T")[0], // Prefill with today's date,
    ledger: "",
    purpose: "",
    vehicleNo: "",
    name: "",
    mobileNo: "",
    totalFreight: "",
    transporterName: "",
    transporterGSTIN: "",
    documentGRNo: "",
    documentGRDate: "",
    receivedGoods: "",
    centerCode: centerCode,
    onAccount: "",
    modeOfTransport: "",
    returnable: false,
    FreightOn: "",
    printFreight: "",
    consolidatedRemarks: "",
    selectedProjects: [],
    trainNo: "",
  });
  const [formData, setFormData] = useState({
    permitBy: "",
    byWhom: "",
    medium: "",
    permitByDate: "",
    permitByTime: "",
    authorityName: "",
    letterIssuerName: "",
  });

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };
  const tabs = ["Challan-Info-tab"];
  if (challanInfo?.modeOfTransport?.value != "Vehicle Itself") {
    tabs.push("Inventory-tab");
  }
  tabs.push("Permission-tab");

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalData, setModalData] = useState(null);
  const location = useLocation();
  const rowData = location.state?.rowData;
  const type = location.state?.type || null;
  const isClone = location.state?.isClone || null;
  const [vehicleOptions, setVehicleOptions] = useState([]);
  const fetchVehicleDetails = async () => {
    try {
      const response = await apiClient.get(`${SERVER_BASE}/getVehicleDetails`);

      // Create options with value & label as vehicleNo
      const options = response.data.map((v) => ({
        value: v.vehicleNo,
        label: `${v.vehicleNo} - ${v.vehicleType}`,
      }));
      setVehicleOptions(options);
    } catch (error) {
      console.error("Error fetching vehicle details:", error);
    }
  };
  // 👇 RUN PREFIX + REFNO UPDATE ONLY AFTER ledger is fully updated in state
  useEffect(() => {
    if (!challanInfo.ledger) return;

    // Avoid running during Edit (when user did NOT change ledger)
    if (rowData && !isClone && challanInfo.ledger.value == originalLedgerId) {
      return;
    }

    // New ledger → fetch prefix + refNo
    fetchPrefix();
  }, [challanInfo.ledger]);

  useEffect(() => {
    if (location.state?.rowData) {
      setEditLoading(true);
      const data = location.state.rowData;

      const selectedProjectsString = data.selectedProjects;
      const selectedProjectIds = selectedProjectsString
        ? selectedProjectsString.split(",").map((id) => parseInt(id))
        : [];
      const selectedProjects = projectOptions.filter((option) =>
        selectedProjectIds.includes(option?.value)
      );

      const ledger = ledgerOptions.find((led) => led.value == data.ledgerId);

      setChallanInfo((prev) => {
        // if type is null -> always overwrite
        if (!isClone) {
          return {
            ...prev,
            dispatchFrom: data.dispatchFrom,
            prefix: { value: data.prefix, label: data.prefix },
            refNo: data.refNo,
            date: data.date,
            ledger: prev.ledger?.value ? prev.ledger : ledger,
            purpose: { value: data.purpose, label: data.purpose },
            vehicleNo: data.vehicleNo || prev.vehicleNo,
            name: data.name || prev.name,
            mobileNo: data.mobileNo || prev.mobileNo,
            totalFreight: data.totalFreight,
            transporterName: {
              value: data.transporterName,
              label: data.transporterName,
            },
            transporterGSTIN: data.transporterGSTIN || prev.transporterGSTIN,
            documentGRNo: data.documentGRNo || prev.documentGRNo,
            documentGRDate: data.documentGRDate || prev.documentGRDate,
            receivedGoods: data.receivedGoods || prev.receivedGoods,
            centerCode: data.centerCode || prev.centerCode,
            onAccount: { value: data.onAccount, label: data.onAccount },
            modeOfTransport: {
              value: data.modeOfTransport,
              label: data.modeOfTransport,
            },
            returnable: data.returnable ?? prev.returnable,
            FreightOn: { value: data.FreightOn, label: data.FreightOn },
            printFreight: {
              value: data.printFreight,
              label: data.printFreight,
            },
            consolidatedRemarks:
              data.consolidatedRemarks || prev.consolidatedRemarks,
            selectedProjects: selectedProjects,
            trainNo: data?.trainNo,
          };
        }

        // if type is NOT null -> do not overwrite ledger/prefix if already set by user
        return {
          ...prev,
          dispatchFrom: data.dispatchFrom,
          prefix: prev.prefix?.value
            ? prev.prefix
            : { value: data.prefix, label: data.prefix },
          refNo: data.refNo,
          // date: data.date,
          ledger: prev.ledger?.value ? prev.ledger : ledger,
          purpose: { value: data.purpose, label: data.purpose },
          vehicleNo: data.vehicleNo || prev.vehicleNo,
          name: data.name || prev.name,
          mobileNo: data.mobileNo || prev.mobileNo,
          totalFreight: data.totalFreight,
          transporterName: {
            value: data.transporterName,
            label: data.transporterName,
          },
          transporterGSTIN: data.transporterGSTIN || prev.transporterGSTIN,
          documentGRNo: data.documentGRNo || prev.documentGRNo,
          documentGRDate: data.documentGRDate || prev.documentGRDate,
          receivedGoods: data.receivedGoods || prev.receivedGoods,
          centerCode: data.centerCode || prev.centerCode,
          onAccount: { value: data.onAccount, label: data.onAccount },
          modeOfTransport: {
            value: data.modeOfTransport,
            label: data.modeOfTransport,
          },
          returnable: data.returnable ?? prev.returnable,
          FreightOn: { value: data.FreightOn, label: data.FreightOn },
          printFreight: { value: data.printFreight, label: data.printFreight },
          consolidatedRemarks:
            data.consolidatedRemarks || prev.consolidatedRemarks,
          selectedProjects: selectedProjects,
        };
      });
      setFormData((prev) => {
        return {
          ...prev,
          permitBy: data?.permitBy,
          byWhom: data?.byWhom,
          medium: data?.medium,
          permitByDate: data?.permitByDate,
          permitByTime: data?.permitByTime,
          letterIssuerName: data?.letterIssuerName,
          authorityName: data?.authorityName, // example: updating a field
        };
      });

      if (Array.isArray(data.itemDetails) && data.itemDetails.length > 0) {
        const rows = data.itemDetails.map((detail, index) => ({
          id: detail.id || index + 1,
          item: detail.itemName?.toString().trim() || "",
          inputValue: detail.quantity?.toString().trim() || "",
          uom: detail.uom?.toString().trim() || "",
          remarks: detail.remarks?.toString().trim() || "",
          returnable: detail.returnable ? parseInt(detail.returnable, 10) : 0,
          itemId: detail.itemId || "",
          locationDetails: detail.locationDetails, // <-- ⭐ ADD THIS
        }));

        setInventoryRows(rows);
        const maxId = Math.max(...rows.map((r) => r.id), 0);
setNextRowId(maxId + 1);
      }
      const selectedLedger = ledgerOptions.find(
        (ledger) => ledger.value == data.ledgerId,
      );

      if (selectedLedger) {
        fetchPurposeByLedger(selectedLedger.group);
      }
      setEditLoading(false);
    }
  }, [location, ledgerOptions, projectOptions]);

  let onAccountOptions = [];
  // if (
  //   challanInfo?.ledger?.state == "Rajasthan" &&
  //   challanInfo?.ledger?.areaJurisdiction == "Yes"
  // ) {
  //   onAccountOptions = [
  //     { value: "Regular", label: "Regular" },
  //     { value: "Visit", label: "Visit" },
  //     { value: "AHQ", label: "AHQ" },
  //     { value: "Project", label: "Project" },
  //   ];
  // } else {
  onAccountOptions = [
    { value: "Regular", label: "Regular" },
    // { value: "Visit", label: "Visit" },
    { value: "AHQ", label: "AHQ" },
    { value: "Project", label: "Project" },
  ];
  // }
  const handleCertificateChange = (newText) => {
    setCertificateText(newText);
  };
  const fetchProjectsByLedger = async (ledgerId) => {
    try {
      const res = await apiClient.get(`${SERVER_BASE}/area-projects`);
      const options = res.data.map((proj) => ({
        value: proj.id,
        label: `${proj.projectName} - [ Code : ${
          proj.projectCode
        } ] - [ Approval No: ${proj.approvalNo} ] - [ Date: ${
          proj.approvalDate ? moment(proj.approvalDate).format("DD-MMM-YY") : ""
        } ]`,
      }));
      setProjectOptions(options);
    } catch (err) {
      console.error("Failed to load projects", err);
    }
  };

  const fetchProfileDetails = async () => {
    try {
      const response = await apiClient.get(`${SERVER_BASE}/getProfile`, {
        params: { email },
      });
      setProfileDetails(response.data?.[0] || null); // Assume the first row contains the profile data
    } catch (err) {
      console.error("Error fetching profile details:", err);
      setProfileDetails(null);
    }
  };

  useEffect(() => {
    fetchProjectsByLedger();
  }, []);
  useEffect(() => {
    fetchProfileDetails();
    fetchVehicleDetails();
  }, []);

  // setRefNo(null)
  const fetchRefNo = async (prefix) => {
    try {
      const response = await apiClient.get(SERVER_BASE + "/generateRefNo", {
        params: { prefix, centerCode },
        headers: {
          Authorization: `Bearer ${token}`, // Add the JWT token in the header
        },
      });
      const formattedRefNo = response.data.refNo.toString().padStart(4, "0");
      setChallanInfo((prev) => ({ ...prev, refNo: formattedRefNo }));
      setPrefix(prefix);
      setRefNo(formattedRefNo);
    } catch (error) {
      console.error("Error fetching reference number:", error);
    }
  };

  const handleNext = () => {
    if (!challanInfo.prefix) {
      Swal.fire({
        toast: true,
        position: "center",
        showConfirmButton: false,
        timerProgressBar: true,
        icon: "warning",
        text: "Please select a prefix before proceeding.",
        timer: 3000,
      });
      return;
    }

    if (!challanInfo.onAccount) {
      Swal.fire({
        toast: true,
        position: "center",
        showConfirmButton: false,
        timerProgressBar: true,
        icon: "warning",
        text: 'The "On Account" field cannot be empty.',
        timer: 3000,
      });
      return;
    }
    if (
      challanInfo?.onAccount?.value != "Project" &&
      !challanInfo.receivedGoods
    ) {
      Swal.fire({
        toast: true,
        position: "center",
        showConfirmButton: false,
        timerProgressBar: true,
        icon: "warning",
        text: 'The "Inventory" field cannot be empty.',
        timer: 3000,
      });
      setLoading(false);
      return;
    }

    if (!challanInfo.ledger) {
      Swal.fire({
        toast: true,
        position: "center",
        showConfirmButton: false,
        timerProgressBar: true,
        icon: "warning",
        text: 'The "Ledger" field cannot be empty.',
        timer: 3000,
      });
      return;
    }

    if (!challanInfo.purpose) {
      Swal.fire({
        toast: true,
        position: "center",
        showConfirmButton: false,
        timerProgressBar: true,
        icon: "warning",
        text: 'The "Purpose" field cannot be empty.',
        timer: 3000,
      });
      return;
    }
    if (
      challanInfo.purpose?.value == "on approval basis" &&
      challanInfo?.receivedGoods == "Now, Sending on Returnable Basis"
    ) {
      Swal.fire({
        toast: true,
        position: "center",
        showConfirmButton: false,
        timerProgressBar: true,
        icon: "warning",
        text: "Can not select 'Sending on Returnable Basis' in case of purpose being on approval basis ",
        timer: 3000,
      });
      return;
    }
    if (!challanInfo.modeOfTransport) {
      Swal.fire({
        toast: true,
        position: "center",
        showConfirmButton: false,
        timerProgressBar: true,
        icon: "warning",
        text: "Mode of Transport cannot be empty.",
        timer: 3000,
      });
      return;
    }

    if (
      (challanInfo.modeOfTransport?.value == "By Train" ||
        challanInfo.modeOfTransport?.value == "By Road") &&
      !challanInfo.vehicleNo
    ) {
      Swal.fire({
        toast: true,
        position: "center",
        showConfirmButton: false,
        timerProgressBar: true,
        icon: "warning",
        text: 'The "Vehicle/Train" field cannot be empty.',
        timer: 3000,
      });
      return;
    }

    if (!challanInfo.name) {
      Swal.fire({
        toast: true,
        position: "center",
        showConfirmButton: false,
        timerProgressBar: true,
        icon: "warning",
        text: 'The "Name" field cannot be empty.',
        timer: 3000,
      });
      return;
    }

    if (!challanInfo.mobileNo) {
      Swal.fire({
        toast: true,
        position: "center",
        showConfirmButton: false,
        timerProgressBar: true,
        icon: "warning",
        text: 'The "Mobile Number" field cannot be empty.',
        timer: 3000,
      });
      return;
    }

    if (!/^\d{10}$/.test(challanInfo.mobileNo)) {
      Swal.fire({
        toast: true,
        position: "center",
        showConfirmButton: false,
        timerProgressBar: true,
        icon: "warning",
        text: 'The "Mobile Number" must be exactly 10 digits.',
        timer: 3000,
      });
      return;
    }
    if (
      !challanInfo.FreightOn &&
      challanInfo?.modeOfTransport?.value != "Vehicle Itself"
    ) {
      Swal.fire({
        toast: true,
        position: "center",
        showConfirmButton: false,
        timerProgressBar: true,
        icon: "warning",
        title: "Missing Information",
        text: 'The "Freight On" field cannot be empty.',
        timer: 3000,
      });
      return;
    }

    if (
      challanInfo.FreightOn?.value == "On Payment" &&
      challanInfo.modeOfTransport?.value != "By Hand"
    ) {
      if (!challanInfo.totalFreight) {
        Swal.fire({
          toast: true,
          position: "center",
          showConfirmButton: false,
          timerProgressBar: true,
          timerProgressBar: true,
          icon: "warning",
          title: "Missing Information",
          text: 'The "Total Freight" field cannot be empty .',
          timer: 3000,
        });
        return;
      }

      if (!challanInfo.transporterName) {
        Swal.fire({
          toast: true,
          position: "center",
          showConfirmButton: false,
          timerProgressBar: true,
          icon: "warning",

          text: 'The "Transporter Name" field cannot be empty .',
          timer: 3000,
        });
        return;
      }

      if (!challanInfo.documentGRNo) {
        Swal.fire({
          toast: true,
          position: "center",
          showConfirmButton: false,
          timerProgressBar: true,
          icon: "warning",
          text: 'The "GR Number" field cannot be empty for "On Payment".',
          timer: 3000,
        });
        return;
      }

      if (!challanInfo.documentGRDate) {
        Swal.fire({
          toast: true,
          position: "center",
          showConfirmButton: false,
          timerProgressBar: true,
          icon: "warning",
          text: 'The "GR Date" field cannot be empty for "On Payment".',
          timer: 3000,
        });
        return;
      }
    }
    if (
      !challanInfo.printFreight &&
      challanInfo?.modeOfTransport?.value != "Vehicle Itself"
    ) {
      Swal.fire({
        toast: true,
        position: "center",
        showConfirmButton: false,
        timerProgressBar: true,
        icon: "warning",
        text: "Choose print Freight Yes or No",
        timer: 3000,
      });
      return;
    }
    // Only validate if mode is NOT "By Hand"
    if (challanInfo?.modeOfTransport?.value != "By Hand") {
      if (
        challanInfo?.modeOfTransport?.value ==
          "By Goods Transportation Agency" ||
        challanInfo?.FreightOn?.value == "On Payment"
      ) {
        if (!challanInfo?.transporterName) {
          Swal.fire({
            toast: true,
            position: "center",
            showConfirmButton: false,
            timerProgressBar: true,
            icon: "warning",
            text: 'The "Transporter Name" field cannot be empty.',
            timer: 3000,
          });
          return;
        }
      }
    }

    // Proceed to the next step
    if (activeTab < tabs.length - 1) setActiveTab(activeTab + 1);
  };

  const handleBack = () => {
    if (activeTab > 0) setActiveTab(activeTab - 1);
  };

  const validateChallan = (challanInfo, submitType) => {
    // Check Ledger
    if (!challanInfo.ledger?.value) {
      return "Please select a ledger before proceeding.";
    }

    // Skip other validations if Draft
    if (submitType !== "Draft") {
      // ✅ Validation 1: Item must be selected
      const invalidItemRow = inventoryRows.find((row) => {
        return !row.item; // item not selected
      });
      
      if (invalidItemRow) {
        const rowNo =
          inventoryRows.findIndex((r) => r.id == invalidItemRow.id) + 1;
      
        return `Item not selected on row ${rowNo}`;
      }
      
      // ✅ Validation 2: Quantity validation except APR items
      const invalidQtyRow = inventoryRows.find((row) => {
        if (row.uom == "APR") return false;

        return !row.inputValue || Number(row.inputValue) <= 0;
      });
      
      if (invalidQtyRow) {
        const rowNo =
          inventoryRows.findIndex((r) => r.id == invalidQtyRow.id) + 1;
        return `Please enter quantity for row ${rowNo}`;
      }
      // ✅ Validation 3: Remarks mandatory for APR items
      const invalidAPRRemarkRow = inventoryRows.find((row) => {
        return row.uom == "APR" && (!row.remarks || row.remarks.trim() == "");
      });

      if (invalidAPRRemarkRow) {
        const rowNo =
          inventoryRows.findIndex((r) => r.id == invalidAPRRemarkRow.id) + 1;

        return `Remarks are mandatory for APR item on row ${rowNo}`;
      }

      if (!challanInfo.onAccount)
        return 'The "On Account" field cannot be empty.';

      if (
        challanInfo?.onAccount?.value !== "Project" &&
        !challanInfo.receivedGoods
      )
        return 'The "Inventory" field cannot be empty.';

      if (!challanInfo.ledger) return 'The "Ledger" field cannot be empty.';

      if (!challanInfo.purpose) return 'The "Purpose" field cannot be empty.';

      if (!challanInfo.modeOfTransport)
        return "Mode of Transport cannot be empty.";

      if (
        (challanInfo.modeOfTransport?.value == "By Train" ||
          challanInfo.modeOfTransport?.value == "By Road") &&
        !challanInfo.vehicleNo
      )
        return 'The "Vehicle/Train" field cannot be empty.';

      if (!challanInfo.name) return 'The "Name" field cannot be empty.';

      if (!challanInfo.mobileNo)
        return 'The "Mobile Number" field cannot be empty.';

      if (!/^\d{10}$/.test(challanInfo.mobileNo))
        return 'The "Mobile Number" must be exactly 10 digits.';

      if (
        !challanInfo.FreightOn &&
        challanInfo?.modeOfTransport?.value !== "Vehicle Itself"
      )
        return 'The "Freight On" field cannot be empty.';

      if (
        challanInfo.FreightOn?.value == "On Payment" &&
        challanInfo.modeOfTransport?.value !== "By Hand" &&
        challanInfo.modeOfTransport?.value !== "Vehicle Itself"
      ) {
        if (!challanInfo.totalFreight)
          return 'The "Total Freight" field cannot be empty for "On Payment".';
        if (!challanInfo.documentGRNo)
          return 'The "GR Number" field cannot be empty for "On Payment".';
        if (!challanInfo.documentGRDate)
          return 'The "GR Date" field cannot be empty for "On Payment".';
      }

      if (
        !challanInfo.printFreight &&
        challanInfo?.modeOfTransport?.value !== "Vehicle Itself"
      )
        return "Choose print Freight Yes or No";

      if (
        challanInfo.purpose?.value == "on approval basis" &&
        challanInfo?.receivedGoods == "Now, Sending on Returnable Basis"
      )
        return "Cannot select 'Sending on Returnable Basis' for purpose 'on approval basis'";

      if (
        challanInfo?.modeOfTransport?.value !== "By Hand" &&
        (challanInfo?.modeOfTransport?.value ==
          "By Goods Transportation Agency" ||
          challanInfo?.FreightOn?.value == "On Payment") &&
        !challanInfo?.transporterName
      )
        return 'The "Transporter Name" field cannot be empty.';


      if (!formData?.permitBy) return `Permitted By field can not be empty`;
      if (
        formData?.permitBy !== "Committee Member" &&
        formData.permitBy !== "Letter or Email from Beas" &&
        !formData?.byWhom
      )
        return `By Whom field cannot be empty`;

      if (
        formData?.permitBy !== "Committee Member" &&
        formData.permitBy !== "Letter or Email from Beas" &&
        !formData.medium
      )
        return `Medium field cannot be empty`;

      if (
        formData?.permitBy !== "Committee Member" &&
        formData.permitBy !== "Letter or Email from Beas" &&
        !formData?.permitByDate
      )
        return `Permitted By Date field cannot be empty`;

      if (
        formData?.permitBy !== "Committee Member" &&
        formData.permitBy !== "Letter or Email from Beas" &&
        !formData?.permitByTime
      )
        return `Permitted Time field cannot be empty`;

      if (formData?.permitBy == "Committee Member" && !formData?.authorityName)
        return `Authority Name field can not be empty`;
      if (
        formData?.permitBy == "Letter or Email from Beas" &&
        !formData?.letterIssuerName
      )
        return `Letter Issuer Name field can not be empty`;
    }

    // No errors
    return null;
  };

  const handleSubmit = async (submitType) => {
    if (loading) return;
    setLoading(true);

    Swal.fire({
      toast: true,
      position: "center",
      showConfirmButton: false,
      timerProgressBar: true,
      icon: "info",
      text: "Please Wait! your internet connection might be slow, this may take some time.",
      timer: 5000,
    });

    const errorMessage = validateChallan(challanInfo, submitType);
    if (errorMessage) {
      Swal.fire({
        toast: true,
        position: "center",
        showConfirmButton: false,
        timerProgressBar: true,
        icon: "warning",
        text: errorMessage,
        timer: 3000,
      });
      setLoading(false);
      return;
    }

    try {
      // Base payload for all challans
      const basePayload = {
        challanInfo,
        inventoryRows,
        certificateText,
        type: rowData && !isClone ? "EditDC" : "DeliveryChallan",
        createdBy: name,
        createdByBadge: badgeId,
        rowData: rowData || null,
        formData: formData,
        status: submitType == "Draft" ? "Draft" : "Pending", // Save as draft by default
        isTesting: 0,
        isClone: isClone,
      };

      // Special handling for "By Goods Transportation Agency" or "By Train" mode
      if (
        (challanInfo.modeOfTransport?.value ==
          "By Goods Transportation Agency" ||
          challanInfo.modeOfTransport?.value == "By Train") &&
        !rowData
      ) {
        const transhipRefNo = await generateTranshipRefNo();

        const transhipPayload = {
          ...basePayload,
          challanInfo: {
            ...challanInfo,
            prefix: { label: "JP/26-27/C-", value: "JP/26-27/C-" },
            refNo: transhipRefNo,
            isTranshipment: true,
            isClone,
          },
        };

        const deliveryPayload = {
          ...basePayload,
          certificateText: normalCertificateText,
          isTranshipment: false,
          isClone,
        };

        // Save transhipment challan
        const response = await apiClient.post(
          SERVER_BASE + "/saveTranshipChallan",
          {
            transhipPayload,
            deliveryPayload,
            createdBy: name,
            createdByBadge: badgeId,
            isClone,
            isTesting: 0,
          },
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        if (response.status == 200 || response.status == 204) {
          Swal.fire({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timerProgressBar: true,
            icon: "success",
            text: "Transhipment and Delivery Challans saved successfully",
            timer: 2000,
          }).then(() => {
            navigate("../deliveryChallanList");
            setUnsavedChanges(false);
            setLoading(false);
          });
        }
      } else {
        let type = "DeliveryChallan";

        if (rowData && !isClone) {
          type = "EditDC";
        }
        if (rowData && isClone) {
          type = "CloneDC";
        }

        const finalPayload = {
          ...basePayload,
          type,
          isClone,
        };
        const API =
          type == "EditDC"
            ? SERVER_BASE + `/editDeliveryChallan/${rowData?.id}`
            : SERVER_BASE + "/saveDeliveryChallan";

        const response = await apiClient.post(API, finalPayload, {
          headers: { Authorization: `Bearer ${token}` },
        });

        Swal.fire({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timerProgressBar: true,
          icon: "success",
          text: response?.data?.message,
          timer: 2000,
        }).then(() => {
          navigate("../deliveryChallanList");
          setUnsavedChanges(false);
          setLoading(false);
        });
      }
    } catch (error) {
      console.error("Error saving challan:", error);
      Swal.fire({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timerProgressBar: true,
        icon: "error",
        text: error.response.data.message,
        timer: 3000,
      });
      setLoading(false);
    }
  };

  const generateTranshipRefNo = async () => {
    try {
      const response = await apiClient.get(SERVER_BASE + "/generateRefNo", {
        params: { prefix: "JP/26-27/C-", centerCode },
        headers: { Authorization: `Bearer ${token}` },
      });
      return response.data.refNo.toString().padStart(4, "0");
    } catch (error) {
      console.error("Error generating tranship refNo:", error);
      return "0001"; // Fallback
    }
  };

  const openModal = (item) => {
    const row = inventoryRows.find((r) => r.id == item.rowId);

    setModalData({
      ...item,
      locationDetails: row?.locationDetails || [], // ← ADD THIS
    });

    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setModalData(null);
  };

  const goodsOptions = [
    // { value: "Received Goods/Returnable Goods", label: "Received Goods/Returnable Goods" },
    { value: "Sending as Transfer", label: "Sending as Transfer " },
    {
      value: "Now, Sending on Returnable Basis",
      label: "Now, Sending on Returnable Basis",
    },
    {
      value: "Earlier Received on Returnable Basis",
      label: "Earlier Received on Returnable Basis",
    },
    {
      value: "Exchange with Condemned Inventory",
      label: "Exchange with Condemned Inventory ",
    },
    {
      value: "Exchange with Earlier issued Inventory",
      label: "Exchange with Earlier Issued Inventory ",
    },
  ]; // Single option for Goods dropdown

  // State for inventory rows
  const [inventoryRows, setInventoryRows] = useState([
    {
      id: 1,
      item: "",
      aliasNames: "",
      quantity: "",
      uom: "",
      remarks: "",
      returnable: 0,
      locationDetails: [],
    },
  ]);

  const updateCertificateText = () => {
    if (
      (challanInfo.modeOfTransport?.value == "By Goods Transportation Agency" ||
        challanInfo.modeOfTransport?.value == "By Train") &&
      !rowData
    ) {
      setCertificateText(
        `This is to certify that the goods listed below are the property of <strong>Radha Soami Satsang Beas</strong> and are being sent to <strong> ${
          challanInfo.transporterName?.value || ""
        }</strong> for further transship to <strong>${
          challanInfo?.ledger?.label || ""
        }</strong>. These goods are being sent duly loaded in vehicle no. <strong>${
          challanInfo.vehicleNo || ""
        }</strong> driven by <strong>${
          challanInfo.name || ""
        }</strong> having Mobile no. <strong>${
          challanInfo.mobileNo || ""
        }</strong>. These goods are not for the purpose of sale or any other commercial use. It is only for satsang use, therefore requested that these may please be allowed to proceed to its destination without any late or hindrance.`
      );
    } else if (
      challanInfo?.receivedGoods == "Earlier Received on Returnable Basis"
    ) {
      setCertificateText(
        `This is to certify that goods below are the property of <strong>${
          challanInfo?.ledger?.ledgerGroupCode == "RS"
            ? "Radha Soami Satsang Beas"
            : challanInfo?.ledger?.label || ""
        }</strong> and were being received in our satsang ghar for satsang use${
          challanInfo?.ledger?.ledgerGroupCode == "RS"
            ? ` from <strong> ${challanInfo?.ledger?.label || ""}</strong>.`
            : `.`
        } The goods listed below were taken <strong>${
          challanInfo?.purpose?.value || ""
        }</strong>. The same are being returned back to <strong>${
          challanInfo?.ledger?.label || ""
        }</strong>. These goods are being ${
          challanInfo?.modeOfTransport?.value == "By Train"
            ? `sent through <strong>${
                challanInfo?.trainNo || ""
              }</strong> by our sewadar `
            : challanInfo?.modeOfTransport?.value == "By Hand"
            ? `handed over to`
            : `sent loaded in vehicle no. <strong>${
                challanInfo.vehicleNo || ""
              }</strong>, driven by `
        }<strong>${challanInfo.name || ""}</strong> having Mobile no. <strong>${
          challanInfo.mobileNo || ""
        }</strong>${
          challanInfo?.modeOfTransport?.value == "By Hand"
            ? ` for destination.`
            : `.`
        } These goods are not for the purpose of sale or any other commercial use. It is only for satsang use. It is therefore requested that these may please be allowed to proceed to their destination without any delay or hindrance.`
      );
    } else {
      setCertificateText(
        `This is to certify that ${
          challanInfo?.modeOfTransport?.value != "Vehicle Itself"
            ? `the goods listed below `
            : `<strong>${challanInfo.vehicleNo || ""}</strong> `
        }${
          challanInfo?.modeOfTransport?.value == "Vehicle Itself" ? `is` : `are`
        } the property of Radha Soami Satsang Beas and ${
          challanInfo?.modeOfTransport?.value == "Vehicle Itself" ? `is` : `are`
        } being sent to 
        <strong>${challanInfo?.ledger?.label || ""}</strong>${
          challanInfo?.purpose?.value
            ? `, <strong>${challanInfo.purpose.value}</strong>`
            : ""
        }. ${
          challanInfo?.modeOfTransport?.value == "Vehicle Itself"
            ? `This vehicle is being driven by `
            : challanInfo?.modeOfTransport?.value == "By Train"
            ? `These goods are being sent through <strong>${
                challanInfo?.trainNo || ""
              }</strong> by our sewadar`
            : `These goods are being ${
                challanInfo?.modeOfTransport?.value == "By Hand"
                  ? `handed over to `
                  : `sent duly loaded in vehicle no. <strong>${
                      challanInfo?.vehicleNo || ""
                    }</strong> driven by `
              }`
        }
        <strong>${challanInfo.name || ""}</strong> having Mobile no. <strong>${
          challanInfo.mobileNo || ""
        }</strong>${
          challanInfo?.modeOfTransport?.value == "By Hand"
            ? ` for destination.`
            : `.`
        }  ${
          challanInfo?.modeOfTransport?.value == "Vehicle Itself"
            ? `This vehicle is `
            : `These goods are`
        } not for the purpose of sale or any other commercial use. It is therefore requested that ${
          challanInfo?.modeOfTransport?.value == "Vehicle Itself"
            ? `this`
            : `these`
        } may please be allowed to proceed to its destination without any delay or hindrance.`
      );
    }
  };
  const updateNormalCertificateText = () => {
    if (challanInfo?.receivedGoods == "Earlier Received on Returnable Basis") {
      setNormalCertificateText(
        `This is to certify that goods below are the property of <strong>${
          challanInfo?.ledger?.ledgerGroupCode == "RS"
            ? "Radha Soami Satsang beas"
            : challanInfo?.ledger?.label || ""
        }</strong> and were being received in our satsang ghar for satsang use. The goods listed below are taken <strong>${
          challanInfo?.purpose?.value || ""
        }</strong>. The same are being returned back to <strong>${
          challanInfo?.ledger?.label || ""
        }</strong>. These goods are being ${
          challanInfo?.modeOfTransport?.value == "By Train"
            ? `sent through <strong>${
                challanInfo?.trainNo || ""
              }</strong> by our sewadar`
            : challanInfo?.modeOfTransport?.value == "By Hand"
            ? `handed over to`
            : `sent loaded in vehicle no. <strong>${
                challanInfo.vehicleNo || ""
              }</strong>, driven by`
        }
        <strong>${challanInfo.name || ""}</strong> having Mobile no. <strong>${
          challanInfo.mobileNo || ""
        }</strong>${
          challanInfo?.modeOfTransport?.value == "By Hand"
            ? ` for destination.`
            : `.`
        }These ${
          challanInfo?.modeOfTransport?.value == "Vehicle Itself"
            ? `vehicle is `
            : `goods are`
        } not for the purpose of sale or any other commercial use. It is therefore requested that these may please be allowed to proceed to their destination without any delay or hindrance.`
      );
    } else {
      setNormalCertificateText(
        `This is to certify that ${
          challanInfo?.modeOfTransport?.value != "Vehicle Itself"
            ? `the goods listed below `
            : `<strong>${challanInfo.vehicleNo || ""}</strong> `
        }${
          challanInfo?.modeOfTransport?.value == "Vehicle Itself" ? `is` : `are`
        } the property of Radha Soami Satsang Beas and ${
          challanInfo?.modeOfTransport?.value == "Vehicle Itself" ? `is` : `are`
        } being sent to 
        <strong>${challanInfo?.ledger?.label || ""}</strong>${
          challanInfo?.purpose?.value
            ? `, <strong>${challanInfo.purpose.value}</strong>`
            : ""
        }.  ${
          challanInfo?.modeOfTransport?.value == "Vehicle Itself"
            ? `This vehicle is being driven by `
            : challanInfo?.modeOfTransport?.value == "By Train"
            ? `These goods are being sent through <strong>${
                challanInfo?.trainNo || ""
              }</strong> by our sewadar `
            : `These goods are being ${
                challanInfo?.modeOfTransport?.value == "By Hand"
                  ? `handed over to `
                  : `sent duly loaded in vehicle no. <strong>${
                      challanInfo?.vehicleNo || ""
                    }</strong> driven by `
              }`
        }<strong>${challanInfo.name || ""}</strong> having Mobile no. <strong>${
          challanInfo.mobileNo || ""
        }</strong>${
          challanInfo?.modeOfTransport?.value == "By Hand"
            ? ` for destination.`
            : `.`
        } These ${
          challanInfo?.modeOfTransport?.value == "Vehicle Itself"
            ? `vehicle is `
            : `goods are`
        } not for the purpose of sale or any other commercial use. It is therefore requested that ${
          challanInfo?.modeOfTransport?.value == "Vehicle Itself"
            ? `this`
            : `these`
        } may please be allowed to proceed to its destination without any delay or hindrance.`
      );
    }
  };

  const updateTranshipCertificateText = () => {
    if (
      challanInfo.modeOfTransport?.value == "By Goods Transportation Agency" ||
      challanInfo.modeOfTransport?.value == "By Train"
    ) {
      setTranshipCertificateText(
        `This is to certify that the goods listed below are the property of <strong>Radha Soami Satsang Beas</strong> and are being sent to <strong> ${
          challanInfo.transporterName?.value || ""
        }</strong> for further transship to <strong>${
          challanInfo?.ledger?.label || ""
        }</strong>. These goods are being sent duly loaded in vehicle no. <strong>${
          challanInfo.vehicleNo || ""
        }</strong> driven by <strong>${
          challanInfo.name || ""
        }</strong> having Mobile no. <strong>${
          challanInfo.mobileNo || ""
        }</strong>. These goods are not for the purpose of sale or any other commercial use. It is only for satsang use, therefore requested that these may please be allowed to proceed to its destination without any late or hindrance.`
      );
    }
  };

  // Automatically update the certificate text when challanInfo changes
  useEffect(() => {
    updateTranshipCertificateText();
    updateNormalCertificateText();
    updateCertificateText();
  }, [challanInfo]);

  useEffect(() => {
    setInventoryRows((prevRows) =>
      prevRows.map((row) => {
        if (
          challanInfo.receivedGoods == "Earlier Received on Returnable Basis"
        ) {
          return { ...row, returnable: 0 };
        } else if (
          challanInfo.receivedGoods == "Now, Sending on Returnable Basis"
        ) {
          return { ...row, returnable: 1 };
        } else {
          return { ...row, returnable: 0 };
        }
      })
    );
  }, [challanInfo.receivedGoods]);

  useEffect(() => {
    if (challanInfo.ledger) {
      fetchPrefix();
    }
  }, [challanInfo.ledger]);

  useEffect(() => {
    fetchPrefix();
    fetchTransportersDetails();
  }, [centerCode]);

  useEffect(() => {
    if (centerCode) {
      fetchInventory();
    }
  }, [centerCode]);

  useEffect(() => {
    fetchledgermasterdetails();
    // fetchTotalQuantityForItem();
  }, []);

  const fetchPurposeByLedger = async (ledgerGroup) => {
    try {
      const response = await apiClient.get(
        SERVER_BASE + "/getPurposeByLedgerForChallan",
        {
          params: { ledgerName: ledgerGroup, code: centerCode },
          headers: {
            Authorization: `Bearer ${token}`, // Add the JWT token in the header
          },
        }
      );

      const options = response.data.map((purpose) => ({
        value: purpose.purposeName, // Adjust based on API response structure
        label: purpose.purposeName,
      }));
      setPurposeOptions(options);
    } catch (error) {
      console.error("Error fetching purposes:", error);
    }
  };

  const fetchInventory = async () => {
    try {
      const response = await apiClient.get(SERVER_BASE + "/inventoryDetails", {
        params: { code: centerCode },
        headers: {
          Authorization: `Bearer ${token}`, // Add the JWT token in the header
        },
      });

      const options = response.data.map((inventory) => ({
        value: inventory.id, // Adjust based on API response structure
        label: `${inventory.printName} ${
          inventory.aliasNames ? ` - [ ${inventory.aliasNames} ]` : ""
        }`,
        aliasNames: inventory.aliasNames,
        quantity: inventory.quantity,
        uom: inventory.uom,
        itemName: inventory.printName,
      }));
      setInventoryOptions(options);
    } catch (error) {
      console.error("Error fetching inventory:", error);
    }
  };

  const handleInventoryChange = async (rowId, field, value, option = null) => {
    const selectedValue = option ? option?.itemName : "";
    const selectedId = option ? option?.value : "";
    if (field == "item") {
      // Check existing selected UOMs excluding current row
      const existingRows = inventoryRows.filter(
        (r) => r.id != rowId && r.itemId
      );
    
      const hasAPRItem = existingRows.some((r) => r.uom == "APR");
    
      const hasNonAPRItem = existingRows.some(
        (r) => r.uom && r.uom != "APR"
      );
    
      // ❌ Prevent APR with non-APR
      if (option?.uom == "APR" && hasNonAPRItem) {
        Swal.fire({
          toast: true,
          position: "center",
          showConfirmButton: false,
          timerProgressBar: true,
          icon: "warning",
          text: "APR items cannot be mixed with non-APR items.",
          timer: 3000,
        });
      
        setInventoryRows((prevRows) =>
          prevRows.map((row) =>
            row.id == rowId
              ? {
                  ...row,
                  item: "",
                  itemId: "",
                  uom: "",
                }
              : row
          )
        );
      
        return;
      }
      
      // ❌ Prevent non-APR with APR
      if (option?.uom != "APR" && hasAPRItem) {
        Swal.fire({
          toast: true,
          position: "center",
          showConfirmButton: false,
          timerProgressBar: true,
          icon: "warning",
          text: "Non-APR items cannot be added when APR item already selected.",
          timer: 3000,
        });
      
        setInventoryRows((prevRows) =>
          prevRows.map((row) =>
            row.id == rowId
              ? {
                  ...row,
                  item: "",
                  itemId: "",
                  uom: "",
                }
              : row
          )
        );
      
        return;
      }
    
      // ✅ Allowed selection
      setInventoryRows((prevRows) =>
        prevRows.map((row) =>
          row.id == rowId
            ? {
                ...row,
                item: selectedValue,
                aliasNames: option
                  ? option.label.match(/\[(.*?)\]/)?.[1] || ""
                  : "",
                uom: option ? option.uom : "",
                itemId: selectedId,
                inputValue: 0,
                locationDetails: [],
              }
            : row
        )
      );

      // Open modal only for non-APR
      if (option && option.uom != "APR") {
        openModal({
          itemName: selectedValue,
          itemId: selectedId,
          centerCode,
          rowId,
          locationDetails:
            inventoryRows.find((r) => r.id == rowId)?.locationDetails || [],
        });
      }
    }else {
      // Handle all other fields
      setInventoryRows((prevRows) =>
        prevRows.map((row) =>
          row.id == rowId ? { ...row, [field]: value } : row,
        ),
      );
    }

    setUnsavedChanges(true);
  };

  const fetchTotalQuantityForItem = async (
    selectedId,
    itemName,
    prefix,
    refNo,
    centerCode
  ) => {
    try {
      const response = await apiClient.get(
        SERVER_BASE + "/inventoryTotalQuantity",
        {
          params: {
            itemId: selectedId,
            itemName,
            prefix: rowData && !isClone ? rowData?.prefix : prefix,
            refNo: rowData && !isClone ? rowData?.refNo : refNo,
            centerCode,
          },
          headers: {
            Authorization: `Bearer ${token}`, // Add the JWT token in the header
          },
        }
      );

      return response?.data; // Return the fetched data
    } catch (error) {
      console.error("Error fetching total quantity:", error);
    }
  };

  const fetchPrefix = async () => {
    try {
      // EDIT MODE → ledger not changed → keep old prefix/refNo
      if (rowData && !isClone && !hasLedgerChanged) {
        setChallanInfo((prev) => ({
          ...prev,
          prefix: { value: rowData.prefix, label: rowData.prefix },
          refNo: rowData.refNo,
        }));
        return; // stop here, do NOT compute new prefix
      }

      // Fetch all prefixes from backend
      const response = await apiClient.get(`${SERVER_BASE}/prefixDetails`, {
        params: { code: centerCode },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      // Convert API data to Select options
      const allPrefixes = response.data.map((pre) => ({
        value: pre.prefix,
        label: pre.prefix,
      }));

      let filteredPrefixes = [];

      // Condition variables
      const ledger = challanInfo.ledger;
      const state = ledger?.state;
      const group = ledger?.ledgerGroupCode;
      const isRS = group == "RS";
      const isRJ = state == "Rajasthan";
      const isMajorOrUnknown = ["MAJOR CENTER", "UNKNOWN"].includes(
        challanInfo.centerType?.toUpperCase()
      );
      const hasJurisdiction =
        challanInfo?.ledger?.areaJurisdiction?.toLowerCase() == "yes";

      // Filtering logic
      if (isRJ && hasJurisdiction) {
        // Area Store → A-
        filteredPrefixes = allPrefixes.filter((opt) =>
          opt.label.includes("/A-")
        );
      } else if (isRS && ((isRJ && isMajorOrUnknown) || !isRJ)) {
        // RSSB → S-
        filteredPrefixes = allPrefixes.filter((opt) =>
          opt.label.includes("/S-")
        );
      } else if (!isRS && isRJ) {
        // Challan → C-
        filteredPrefixes = allPrefixes.filter((opt) =>
          opt.label.includes("/C-")
        );
      } else {
        // Default → S-
        filteredPrefixes = allPrefixes.filter((opt) =>
          opt.label.includes("/S-")
        );
      }

      // Auto-select first prefix
      const selectedPrefix = filteredPrefixes[0] || null;
      setPrefixOptions(filteredPrefixes);

      if (selectedPrefix) {
        setChallanInfo((prev) => ({
          ...prev,
          prefix: selectedPrefix,
        }));
        fetchRefNo(selectedPrefix.value);
      } else {
        setChallanInfo((prev) => ({
          ...prev,
          prefix: null,
          refNo: "",
        }));
      }
    } catch (error) {
      console.error("Error fetching prefix:", error);
    }
  };

  const fetchTransportersDetails = async () => {
    try {
      const response = await apiClient.get(
        SERVER_BASE + "/getTransportersDetails",
        {
          params: { code: centerCode },
          headers: {
            Authorization: `Bearer ${token}`, // Add the JWT token in the header
          },
        }
      );

      // Map the response data to options for the Select component
      const options = response.data.map((trans) => ({
        value: trans.ledgerName,
        label: trans.ledgerName,
        gstin: trans.gstin,
      }));
      setTranportersOptions(options);
    } catch (error) {
      console.error("Error fetching prefix:", error);
    }
  };

  const fetchledgermasterdetails = async () => {
    try {
      const response = await apiClient.get(SERVER_BASE + "/ledgerMasters", {
        headers: {
          Authorization: `Bearer ${token}`, // Add the JWT token in the header
        },
      });
      const options = response.data.map((ledger) => ({
        value: ledger?.id,
        label: ledger?.printName,
        group: ledger?.ledgerGroup,
        address: ledger?.address,
        gstin: ledger?.gstin,
        state: ledger?.state,
        stateCode: ledger?.stateCode,
        areaJurisdiction: ledger?.areaJurisdiction,
        ledgerGroupCode: ledger?.ledgerGroupCode,
        centerType: ledger?.centerType,
        maintainBalance: ledger?.maintainBalance,
      }));
      setLedgerOptions(options);
      // setledgerMasterData(response.data);
    } catch (error) {
      console.error("Error fetching ledger master details:", error);
    }
  };

  // const addRow = () => {
  //   const returnableValue =
  //     challanInfo.receivedGoods == "Now, Sending on Returnable Basis" ? 1 : 0;
  
  //   setInventoryRows((prev) => [
  //     ...prev,
  //     {
  //       id: nextRowId, // ✅ unique always
  //       item: "",
  //       quantity: "",
  //       uom: "",
  //       remarks: "",
  //       returnable: returnableValue,
  //       locationDetails: [],
  //     },
  //   ]);
  
  //   setNextRowId((prev) => prev + 1); // ✅ increment
  //   setUnsavedChanges(true);
  // };
  
  const addRow = () => {
  const returnableValue =
      challanInfo.receivedGoods ==
      "Now, Sending on Returnable Basis"
        ? 1
        : 0;
  
    setInventoryRows((prev) => [
      ...prev,
      {
        id: nextRowId, // ✅ unique permanent ID
        item: "",
        itemId: "",
        aliasNames: "",
        inputValue: "",
        uom: "",
        remarks: "",
        returnable: returnableValue,
        locationDetails: [],
      },
    ]);

    setNextRowId((prev) => prev + 1);
  
  setUnsavedChanges(true);
};

  // Delete a row
  const deleteRow = (id) => {
    if (inventoryRows.length > 1) {
      setInventoryRows(inventoryRows.filter((row) => row.id !== id));
      setUnsavedChanges(true);
    } else {
      alert("At least one row must remain.");
    }
  };
  

  useEffect(() => {
    setIsPrefixEmpty(challanInfo.prefix == ""); // Set flag if prefix is empty
  }, [challanInfo.prefix]);
  const [originalLedgerId, setOriginalLedgerId] = useState(null);

  useEffect(() => {
    if (rowData && !isClone) {
      setOriginalLedgerId(rowData.ledgerId); // Save original ledger
    }
  }, [rowData]);

  const handleChallanChange = (field, value) => {
    setChallanInfo((prevInfo) => {
      if (field == "modeOfTransport") {
        const updatedInfo = {
          ...prevInfo,
          vehicleNo: "", // clear vehicle no
          FreightOn: "",
          transporterName:
            value?.value == "By Train"
              ? { label: "INDIAN RAILWAY", value: "INDIAN RAILWAY" }
              : "",
          transporterGSTIN: "",
          documentGRNo: null,
          documentGRDate: null,
          totalFreight: "",
          modeOfTransport: value, // update mode
        };

        return updatedInfo;
      }
      if (field == "FreightOn") {
        const updatedInfo = {
          ...prevInfo,
          totalFreight: null,
          transporterName:
            challanInfo?.modeOfTransport?.value == "By Train"
              ? { label: "INDIAN RAILWAY", value: "INDIAN RAILWAY" }
              : "",
          transporterGSTIN: "",
          documentGRNo: null,
          documentGRDate: null,
          FreightOn: value,
        };
        return updatedInfo;
      }
      if (field == "ledger") {
        const newLedgerId = value?.value;

        // Detect ledger changed
        if (!isClone && rowData) {
          setHasLedgerChanged(newLedgerId !== originalLedgerId);
        }

        // CASE 1: User switched back to original ledger
        if (!isClone && rowData && newLedgerId == originalLedgerId) {
          return {
            ...prevInfo,
            ledger: value,
            prefix: { value: rowData.prefix, label: rowData.prefix },
            refNo: rowData.refNo,

            // selectedProjects: []
          };
        }

        // CASE 2: NEW LEDGER → blank prefix + refNo (fetch fresh)
        const updatedInfo = {
          ...prevInfo,
          ledger: value,
          prefix: null,
          refNo: "",
          onAccount: null,
          purpose: null,
          // selectedProjects: []
        };

        // Fetch new prefix/refNo
        if (value) {
          const selectedLedger = ledgerOptions.find(
            (l) => l.value == value.value
          );

          if (selectedLedger) {
            fetchPurposeByLedger(selectedLedger.group);
            // fetchProjectsByLedger(value.value);
            // fetchPrefix();  // ❗️ This will now run properly
          }
        }

        return updatedInfo;
      }
      if (field == "transporterName") {
        if (!value) {
          return {
            ...prevInfo,
            transporterName: null,
            transporterGSTIN: "",
          };
        }

        const selectedTransporter = TranportersOptions.find(
          (option) => option.value == value.value
        );
        return {
          ...prevInfo,
          transporterName: value,
          transporterGSTIN: selectedTransporter?.gstin || "",
        };
      }
      if (field == "onAccount") {
        const updatedInfo = {
          ...prevInfo,
          onAccount: value,
          receivedGoods: null,
          // selectedProjects:[]
        };
        return updatedInfo;
      }
      return { ...prevInfo, [field]: value };
    });

    setUnsavedChanges(true);
  };
  return (
    <>
      {editLoading && (
        <div className="position-fixed top-50 start-50 translate-middle">
          <div className="text-center">
            <div
              className="spinner-border text-primary"
              style={{ width: "3rem", height: "3rem" }}
              role="status"
            >
              <span className="visually-hidden">Loading...</span>
            </div>
            <div className="mt-2">Loading Challan Data...</div>
          </div>
        </div>
      )}

      <div className="formcontainer mt-5">
        <div className="d-flex justify-content-between">
          <div className="d-flex justify-content-between gap-2">
            <button
              className="btn btn-success mb-3"
              onClick={() => {
                navigate("../DeliveryChallanList");
              }}
            >
              Back to Listing
            </button>
            <h3 className="">Delivery Challan</h3>
          </div>
          <h5 className="text-end">
            {!rowData || isClone
              ? challanInfo?.prefix?.value
              : challanInfo?.ledger?.value == originalLedgerId
              ? rowData.prefix
              : challanInfo?.prefix?.value}
            {!rowData || isClone
              ? challanInfo?.refNo
              : challanInfo?.ledger?.value == originalLedgerId
              ? rowData.refNo
              : challanInfo?.refNo}
          </h5>

          <h5>
            Date :{" "}
            {challanInfo.date
              ? moment(challanInfo.date).format("DD-MMM-YY")
              : ""}
          </h5>
        </div>
        {/* Tabs */}{" "}
        <ul className="nav nav-tabs">
          {tabs.map((tab, index) => (
            <li className="nav-item" key={tab}>
              <button
                className={`nav-link ${activeTab == index ? "active" : ""}`}
                onClick={() => {
                  if (!challanInfo.prefix && index !== 0) {
                    // alert("Please select a prefix before switching tabs.");
                    Swal.fire({
                      toast: true,
                      position: "center",
                      showConfirmButton: false,
                      timerProgressBar: true,
                      icon: "error",
                      text: "Please select a prefix before switching tabs.",
                      timer: 3000,
                    });
                    return; // Prevent tab switch
                  }
                  setActiveTab(index); // Allow tab switch
                }}
                disabled={challanInfo.prefix == "" && index !== 0} // Disable other tabs when prefix is empty
              >
                {tab.replace("-tab", "").replace("-", " ")}
              </button>
            </li>
          ))}
        </ul>
        {/* Tab Content */}
        <div className="tab-content mt-3">
          {/* Inventory Tab */}
          {challanInfo?.modeOfTransport?.value != "Vehicle Itself" ? (
            <>
              <div
                className={`tab-pane fade ${
                  activeTab == 1 ? "show active" : ""
                }`}
                id="Inventory-tab"
              >
                {/* Header Row (only once) */}
                <div className="row mb-2 fw-bold">
                  <div className="col-md-1 p-0">S.No</div>
                  <div className="col-md-4">Item Name</div>
                  <div className="col-md-1">Quantity</div>
                  <div className="col-md-1">UOM</div>
                  <div className="col-md-2">Remarks</div>
                  <div className="col-md-1">Returnable</div>
                  <div className="col-md-1">Actions</div>
                </div>

                {/* Data Rows */}
                {inventoryRows.map((row, index) => {
                  const selectedInventory = inventoryOptions.find(
                    (option) => option.value == row.item
                  );

                  return (
                    <div key={row.id} className="row mb-2">
                      <div className="col-md-1 p-0">
                        <input
                          type="number"
                          className="form-control"
                          value={index + 1}
                          disabled
                        />
                      </div>

                      <div className="col-md-4">
                        <Select
                          options={inventoryOptions}
                          value={
                            inventoryOptions.find(
                            (option) => option?.value == row.itemId
                            ) || null
                          }
                          onChange={(option) =>
                            handleInventoryChange(row.id, "item", null, option)
                          }
                          placeholder="Select Item"
                          isClearable
                        />
                      </div>

                      <div className="col-md-1">
                        <input
                          type="number"
                          className="form-control"
                          value={row.inputValue || ""}
                          onChange={(e) =>
                            handleInventoryChange(
                              row.id,
                              "inputValue",
                              e.target.value,
                            )
                          }
                          placeholder="Total Quantity"
                          disabled
                        />
                      </div>

                      <div className="col-md-1">
                        <input
                          type="text"
                          className="form-control"
                          value={row.uom || ""}
                          onChange={(e) =>
                            handleInventoryChange(row.id, "uom", e.target.value)
                          }
                          placeholder="UOM"
                          disabled
                        />
                      </div>

                      <div className="col-md-2">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Remarks"
                          value={row.remarks}
                          onChange={(e) =>
                            handleInventoryChange(
                              row.id,
                              "remarks",
                              e.target.value,
                            )
                          }
                        />
                      </div>

                      <div className="col-md-1">
                        <select
                          className="form-select"
                          value={row.returnable ?? 0}
                            onChange={(e) =>
                              handleInventoryChange(
                                row.id,
                                "returnable",
                              parseInt(e.target.value, 10),
                              )
                            }
                            disabled={
                              challanInfo.receivedGoods ==
                                "Earlier Received on Returnable Basis" ||
                              challanInfo.receivedGoods ==
                                "Now, Sending on Returnable Basis"
                            }
                        >
                          <option value={0}>No</option>
                          <option value={1}>Yes</option>
                        </select>
                      </div>

                      <div className="col-md-1">
                        <div className="d-flex gap-2">
                          <button className="btn btn-success" onClick={addRow}>
                            <FontAwesomeIcon icon={faPlus} />
                          </button>
                          <button
                            className="btn btn-danger"
                            onClick={() => deleteRow(row.id)}
                            disabled={inventoryRows.length == 1}
                          >
                            <FontAwesomeIcon icon={faTrash} />
                          </button>
                        </div>
                      </div>
                    </div>
                  );
                })}

                {isModalOpen && (
                  <InventoryModal
                    isOpen={isModalOpen}
                    onRequestClose={closeModal}
                    data={modalData}
                    refNo={challanInfo.refNo}
                    prefix={challanInfo?.prefix?.value}
                    rowData={rowData}
                    type={type}
                    isClone={isClone}
                    fetchTotalQuantityForItem={fetchTotalQuantityForItem}
                    onSave={(locationDetails) => {
                      const totalUserQty = locationDetails.reduce(
                        (sum, loc) => sum + (parseFloat(loc.userQuantity) || 0),
                        0
                      );

                      setInventoryRows((prev) =>
                        prev.map((r) =>
                          r.id == modalData.rowId
                            ? {
                                ...r,
                                locationDetails,
                                inputValue: totalUserQty, // <-- UPDATE TOTAL HERE
                              }
                            : r
                        )
                      );
                    }}
                  />
                )}
              </div>
            </>
          ) : null}

          <div
            className={`tab-pane fade ${activeTab == 0 ? "show active" : ""}`}
            id="Challan-Info-tab"
          >
            <div className="row">
              {/* Ledger */}
              <div className="col-md-8 mb-3">
                <label className="form-label">Ledger</label>
                <Select
                  options={ledgerOptions}
                  value={challanInfo.ledger}
                  onChange={(option) => handleChallanChange("ledger", option)}
                  isClearable
                  classNamePrefix="react-select"
                  className={
                    !challanInfo.ledger ? "border border-danger rounded" : ""
                  }
                />
              </div>

              {/* Purpose */}
              <div className="col-md-4 mb-3">
                <label className="form-label">Purpose</label>
                <Select
                  options={purposeOptions}
                  value={challanInfo?.purpose}
                  onChange={(option) => handleChallanChange("purpose", option)}
                  placeholder="Select Purpose"
                  isClearable
                  classNamePrefix="react-select"
                  className={
                    !challanInfo.purpose ? "border border-danger rounded" : ""
                  }
                />
              </div>
            </div>

            <div className="row">
              {/* On Account */}
              <div className="col-md-3 mb-3">
                <label className="form-label">On Account</label>
                <Select
                  options={onAccountOptions}
                  value={challanInfo?.onAccount}
                  onChange={(option) =>
                    handleChallanChange("onAccount", option)
                  }
                  placeholder="Select On Account"
                  isClearable
                  className={
                    !challanInfo?.onAccount
                      ? "border border-danger rounded"
                      : ""
                  }
                />
              </div>
              <div className="col-md-5 mb-3">
                <label className="form-label">Projects</label>
                <Select
                  options={projectOptions}
                  value={challanInfo?.selectedProjects}
                  onChange={(selectedOptions) =>
                    handleChallanChange("selectedProjects", selectedOptions)
                  }
                  isMulti
                  placeholder="Select Projects"
                  className={
                    !challanInfo?.selectedProjects?.length
                      ? "border border-danger rounded"
                      : ""
                  }
                />
              </div>

              <div className="col-md-4 mb-3">
                <label className="form-label">Inventory</label>
                <Select
                  options={goodsOptions}
                  value={
                    goodsOptions.find(
                      (option) => option.value == challanInfo.receivedGoods,
                    ) || null
                  }
                  onChange={(option) => {
                    handleChallanChange(
                      "receivedGoods",
                      option ? option.value : null,
                    );
                    updateCertificateText(option?.value);
                  }}
                  className={
                    !challanInfo?.receivedGoods
                      ? "border border-danger rounded"
                      : ""
                  }
                />
              </div>
            </div>
            <div className="border-top mt-4 mb-3 border-success"></div>
            {/* On Sewa Checkbox */}
            <div className="row">
              <div className="col-md-3">
                <label className="form-label">Mode</label>
                <Select
                  options={ModeOfTransportOptions}
                  value={challanInfo.modeOfTransport}
                  onChange={(option) =>
                    handleChallanChange("modeOfTransport", option)
                  }
                  placeholder="Mode of transport"
                  isClearable
                  className={
                    !challanInfo.modeOfTransport
                      ? "border border-danger rounded"
                      : ""
                  }
                />
              </div>

              <div className="col-md-3">
                <label className="form-label">
                  {challanInfo.modeOfTransport?.value == "By Satsang Vehicle" ||
                  challanInfo.modeOfTransport?.value == "Vehicle Itself"
                    ? "Select Vehicle"
                    : "Vehicle No"}
                </label>

                {challanInfo.modeOfTransport?.value == "By Satsang Vehicle" ||
                challanInfo.modeOfTransport?.value == "Vehicle Itself" ? (
                  <Select
                    name="vehicleNumber"
                    options={vehicleOptions}
                    value={
                      vehicleOptions.find(
                        (opt) => opt.value == challanInfo.vehicleNo,
                      ) || null
                    }
                    onChange={(selected) =>
                      handleChallanChange(
                        "vehicleNo",
                        selected ? selected.value : "",
                      )
                    }
                    classNamePrefix="react-select"
                  />
                ) : (
                  <input
                    type="text"
                    className={`form-control ${
                      challanInfo.modeOfTransport?.value !== "By Hand" &&
                      !challanInfo.vehicleNo
                        ? "border border-danger"
                        : ""
                    }`}
                    value={challanInfo.vehicleNo}
                    onChange={(e) =>
                      handleChallanChange("vehicleNo", e.target.value)
                    }
                    disabled={challanInfo.modeOfTransport?.value == "By Hand"}
                  />
                )}
              </div>
              {challanInfo?.modeOfTransport?.value == "By Train" && (
                <div className="col-md-3">
                  <label className="form-label">Train No</label>
                  <input
                    type="text"
                    className={`form-control ${
                      challanInfo.modeOfTransport?.value != "By Hand" &&
                      !challanInfo.trainNo
                        ? "border border-danger"
                        : ""
                    }`}
                    value={challanInfo.trainNo}
                    onChange={(e) =>
                      handleChallanChange("trainNo", e.target.value)
                    }
                    disabled={challanInfo.modeOfTransport?.value == "By Hand"}
                  />
                </div>
              )}
              <div className="col-md-3">
                <label className="form-label">Name</label>
                <input
                  type="text"
                  className={`form-control ${
                    !challanInfo.name ? "border border-danger" : ""
                  }`}
                  value={challanInfo.name}
                  onChange={(e) => handleChallanChange("name", e.target.value)}
                />
              </div>

              <div className="col-md-3">
                <label className="form-label">Mobile No</label>
                <input
                  type="text"
                  className={`form-control ${
                    !challanInfo.mobileNo ? "border border-danger" : ""
                  }`}
                  value={challanInfo.mobileNo}
                  onChange={(e) =>
                    handleChallanChange("mobileNo", e.target.value)
                  }
                />
              </div>
              {challanInfo?.modeOfTransport?.value != "Vehicle Itself" && (
                <>
                  <div className="col-md-3">
                    <label className="form-label">Freight on</label>
                    <Select
                      options={[
                        { label: "On Sewa", value: "On Sewa" },
                        { label: "On Payment", value: "On Payment" },
                      ]}
                      value={challanInfo.FreightOn}
                      onChange={(option) =>
                        handleChallanChange("FreightOn", option)
                      }
                      placeholder="Select Freight On"
                      isClearable
                    />
                  </div>
                </>
              )}
              {challanInfo?.modeOfTransport?.value != "Vehicle Itself" && (
                <>
                  {challanInfo.FreightOn?.value != "On Sewa" &&
                    challanInfo.FreightOn?.value != "Not Applicable" && (
                      <>
                        <div className="col-md-3">
                          <label className="form-label">Total Freight</label>
                          <input
                            type="text"
                            className="form-control"
                            value={challanInfo.totalFreight}
                            onChange={(e) =>
                              handleChallanChange(
                                "totalFreight",
                                e.target.value
                              )
                            }
                            disabled={
                              challanInfo.modeOfTransport?.value == "By Hand"
                            } // Disable if "By Hand" is selected
                          />
                        </div>
                      </>
                    )}{" "}
                </>
              )}
              {(challanInfo.modeOfTransport?.value ==
                "By Goods Transportation Agency" ||
                challanInfo.modeOfTransport?.value == "By Train" ||
                (challanInfo.modeOfTransport?.value !==
                  "By Goods Transportation Agency" &&
                  challanInfo.modeOfTransport?.value !== "By Train" &&
                  challanInfo.FreightOn?.value == "On Payment")) && (
                <>
                  <div className="col-md-3">
                    <label className="form-label">Transporter Name</label>
                    <Select
                      options={TranportersOptions}
                      value={
                        challanInfo.modeOfTransport?.value == "By Train"
                          ? { label: "INDIAN RAILWAY", value: "INDIAN RAILWAY" }
                          : challanInfo.transporterName
                      }
                      onChange={(option) =>
                        handleChallanChange("transporterName", option)
                      }
                      isClearable={
                        challanInfo.modeOfTransport?.value !== "By Train"
                      } // prevent clearing if By Train
                      isDisabled={
                        challanInfo.modeOfTransport?.value == "By Hand" ||
                        challanInfo.modeOfTransport?.value == "By Train" // lock select if By Train
                      }
                    />
                  </div>

                  <div className="col-md-3">
                    <label className="form-label">Transporter GSTIN</label>
                    <input
                      type="text"
                      className="form-control"
                      value={challanInfo.transporterGSTIN}
                      onChange={(e) =>
                        handleChallanChange("transporterGSTIN", e.target.value)
                      }
                      readOnly={challanInfo.modeOfTransport?.value == "By Hand"} // open if By Train
                      disabled={challanInfo.modeOfTransport?.value == "By Hand"}
                    />
                  </div>
                </>
              )}

              {challanInfo.modeOfTransport?.value != "Vehicle Itself" && (
                <>
                  {challanInfo.FreightOn?.value != "On Sewa" &&
                    challanInfo.FreightOn?.value != "Not Applicable" && (
                      <>
                        <div className="col-md-3">
                          <label className="form-label">Document/GR No.</label>
                          <input
                            type="text"
                            className="form-control"
                            value={challanInfo.documentGRNo}
                            onChange={(e) =>
                              handleChallanChange(
                                "documentGRNo",
                                e.target.value
                              )
                            }
                            disabled={
                              challanInfo.modeOfTransport?.value == "By Hand"
                            } // Disable if "By Hand" is selected
                          />
                        </div>

                        <div className="col-md-3">
                          <label className="form-label">Document/GR Date</label>
                          <input
                            type="date"
                            className="form-control"
                            value={challanInfo.documentGRDate}
                            onChange={(e) =>
                              handleChallanChange(
                                "documentGRDate",
                                e.target.value
                              )
                            }
                            disabled={
                              challanInfo.modeOfTransport?.value == "By Hand"
                            } // Disable if "By Hand" is selected
                          />
                        </div>
                      </>
                    )}
                </>
              )}
              {challanInfo?.modeOfTransport?.value != "Vehicle Itself" && (
                <div className="col-md-3">
                  <label className="form-label">Print Freight Details</label>
                  <Select
                    options={[
                      { label: "Yes", value: "Yes" },
                      { label: "No", value: "No" },
                    ]}
                    value={challanInfo.printFreight}
                    onChange={(option) =>
                      handleChallanChange("printFreight", option)
                    }
                    placeholder="Select Freight Details"
                    isClearable
                  />
                </div>
              )}
              <div className="col-md-3">
                <label className="form-label">Remarks</label>
                <input
                  type="text"
                  className="form-control"
                  value={challanInfo.consolidatedRemarks}
                  onChange={(e) =>
                    handleChallanChange("consolidatedRemarks", e.target.value)
                  }
                />
              </div>
            </div>
            <div
              className=" mt-4"
              style={{ borderTop: "1px solid green" }}
            ></div>

            <div className="mt-3">
              <h4 className="mb-3 text-center">To whomsoever it may concern</h4>

              {/* Certificate text area */}
              <div
                className="form-control"
                rows="8"
                contentEditable={isEditable}
                // style={{ whiteSpace: 'pre-wrap' }}
                // Use plain inner HTML and allow updates without using dangerouslySetInnerHTML
                onInput={(e) => handleCertificateChange(e.target.innerHTML)}
                dangerouslySetInnerHTML={{
                  __html: certificateText,
                }}
              />
            </div>
          </div>

          <div
            className={`tab-pane fade ${
              activeTab == tabs.length - 1 ? "show active" : ""
            }`}
            id="Permission-tab"
          >
            <div className="row">
              <div className="col-md-3">
                <label className="form-label">Permitted By</label>
                <select
                  className="form-select"
                  name="permitBy"
                  value={formData.permitBy}
                  onChange={handleChange}
                >
                  <option value="">Select</option>
                  <option value="Secretary">Secretary</option>
                  <option value="President">President</option>
                  <option value="Committee Member">Committee Member</option>
                  <option value="Letter or Email from Beas">
                    Letter or Email from Beas
                  </option>
                </select>
              </div>

              {/* Conditionally show if not Letter */}
              {formData.permitBy !== "Letter or Email from Beas" && (
                <>
                  <div className="col-md-2">
                    <label className="form-label">By Whom</label>
                    <select
                      className="form-select"
                      name="byWhom"
                      value={formData.byWhom}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option value="Self">Self</option>
                      <option value="Incharge of Deptartment">
                        Incharge of Deptartment
                      </option>
                    </select>
                  </div>

                  <div className="col-md-2">
                    <label className="form-label">Medium</label>
                    <select
                      className="form-select"
                      name="medium"
                      value={formData.medium}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>
                      <option value="Call">Call</option>
                      <option value="WhatsApp">WhatsApp</option>
                      <option value="Email">Email</option>
                      <option value="Face To Face">Face To Face</option>
                    </select>
                  </div>
                </>
              )}

              {/* Date Field */}
              <div className="col-md-2">
                <label className="form-label">
                  {formData.permitBy == "Letter or Email from Beas"
                    ? "Letter Date"
                    : "Date"}
                </label>
                <input
                  type="date"
                  className="form-control"
                  name="permitByDate"
                  value={formData.permitByDate}
                  onChange={handleChange}
                />
              </div>

              {/* Time Field (only when not Letter) */}
              {formData.permitBy != "Letter or Email from Beas" && (
                <div className="col-md-2">
                  <label className="form-label">Time</label>
                  <input
                    type="time"
                    className="form-control"
                    name="permitByTime"
                    value={formData.permitByTime}
                    onChange={handleChange}
                  />
                </div>
              )}

              {/* Name of Authority for Committee Member */}
              {formData.permitBy == "Committee Member" && (
                <div className="col-md-3">
                  <label className="form-label">Name of Authority</label>
                  <input
                    type="text"
                    className="form-control"
                    name="authorityName"
                    value={formData.authorityName}
                    onChange={handleChange}
                  />
                </div>
              )}

              {/* Letter Issuer Name if Letter selected */}
              {formData.permitBy == "Letter or Email from Beas" && (
                <div className="col-md-3">
                  <label className="form-label">Letter Issuer Name</label>
                  <input
                    type="text"
                    className="form-control"
                    name="letterIssuerName"
                    value={formData.letterIssuerName}
                    onChange={handleChange}
                  />
                </div>
              )}
            </div>
          </div>

          {/* Navigation Buttons */}

          <div className="d-flex justify-content-between mt-4">
            <button
              className="btn btn-success"
              onClick={handleBack}
              disabled={activeTab == 0}
            >
              Back
            </button>

            <div className="d-flex gap-2">
              {activeTab < tabs.length - 1 ? (
                <button className="btn btn-success" onClick={handleNext}>
                  Next
                </button>
              ) : (
                <>
                  <button
                    className="btn btn-secondary"
                    disabled={loading}
                    onClick={() => handleSubmit("Draft")}
                  >
                    Save as Draft
                  </button>
                  <button
                    className="btn btn-success"
                    disabled={loading}
                    onClick={() => handleSubmit("Pending")}
                  >
                    Save
                  </button>
                </>
              )}
            </div>
          </div>
          {/* <ChallanSubmissionModal
            show={showPermissionModal}
            onClose={() => setShowPermissionModal(false)}
            onSubmit={(permissionFormData) => {
              setShowPermissionModal(false);
              handlePermissionSubmit(permissionFormData);
            }}
          /> */}
        </div>
      </div>
    </>
  );
};

export default DeliveryChallan;
